export default __webpack_public_path__ + "static/media/71619-coding.100a1bc3.gif";